import { Box, Button, IconButton, Typography } from '@mui/material';
import { ArrowLeftIcon } from './CustomIcons';

interface TaskDetailsProps {
  title: string;
  description: string;
  buttonText: string;
  imgSrc: string;
  imgAlt?: string;
  imgWidth?: string;
  handleClick: () => void;
  handleClose: () => void;
}

const TaskDetails = ({
  title,
  description,
  imgSrc,
  imgAlt,
  imgWidth,
  buttonText,
  handleClick,
  handleClose,
}: TaskDetailsProps) => {
  return (
    <Box
      sx={{ bgcolor: 'primary.main', pt: 8, px: 3, pb: 7.25 }}
      className="d-flex flex-column align-items-start flex-1"
    >
      <Box mb={5.75}>
        <IconButton
          aria-label="back"
          sx={{ color: 'common.white', p: 0, mb: 4 }}
          onClick={handleClose}
        >
          <ArrowLeftIcon sx={{ fontSize: 40 }} />
        </IconButton>
        <Typography variant="h4" color="common.white" mb={1.5}>
          {title}
        </Typography>
        <Typography variant="subtitle2" sx={{ color: 'ghostWhite.main' }}>
          {description}
        </Typography>
      </Box>
      <Box mb={9} className="d-flex justify-content-center w-100">
        <img src={imgSrc} alt={imgAlt} width={imgWidth} />
      </Box>
      <Button
        variant="contained"
        color="info"
        size="large"
        fullWidth
        sx={{ mt: 'auto' }}
        onClick={handleClick}
      >
        {buttonText}
      </Button>
    </Box>
  );
};

export default TaskDetails;
